import React from 'react';
import PropTypes from 'prop-types';
import { BaasicTableExportTemplate } from 'themes/components';
import { setCurrentView } from 'core/utils';
import { BaasicTableExportViewStore } from 'common/stores';

@setCurrentView((rootStore, props) => new BaasicTableExportViewStore(rootStore, props), 'baasicTableExportViewStore')
class BaasicTableExport extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <BaasicTableExportTemplate viewStore={this.props.baasicTableExportViewStore} />
	}
}

BaasicTableExport.propTypes = {
	tableViewStore: PropTypes.object,
	fileTitle: PropTypes.string,
	findFunc: PropTypes.func
}

export default BaasicTableExport;



// WEBPACK FOOTER //
// ./src/core/components/table/BaasicTableExport.jsx